function getProductDisplayName(item) {
    if (item && item.display_name && item.display_name.trim()) {
        return item.display_name
    }

    const segments = []

    if (item && item.brand && item.brand.trim()) {
        segments.push(item.brand.trim())
    }

    if (item && item.item_name && item.item_name.trim()) {
        let itemNameSegment = item.item_name.trim()

        if (item.strain && item.strain.trim()) {
            itemNameSegment += ` ${item.strain.trim()}`
        }

        segments.push(itemNameSegment)
    }

    let weightSegment = ""
    if (item && item.net_weight && item.weight_uom) {
        weightSegment = `${item.net_weight}${item.weight_uom}`
    } else if (item && item.weight && item.weight.trim()) {
        weightSegment = item.weight.trim()
    }

    if (weightSegment) {
        segments.push(weightSegment)
    }

    return segments.length > 0 ? segments.join(" - ") : (item && (item.item_name || item.name)) || "Product"
}

export { getProductDisplayName }
